<!-- src/components/TopBar.svelte -->
<script>
  import { agentStore } from '$lib/stores'

  let searchQuery = ''
  let currentTimestamp = new Date().toLocaleTimeString()

  setInterval(() => {
    currentTimestamp = new Date().toLocaleTimeString()
  }, 1000)

  $: activeCount = $agentStore.runs.filter(r => r.status === 'running').length
  $: pendingCount = $agentStore.runs.filter(r => r.status === 'pending').length
</script>

<header class="topbar glass-panel">
  <div class="topbar-left">
    <div class="search-box">
      <span class="search-icon">⌕</span>
      <input type="text" placeholder="Search agents, leads, providers..." bind:value={searchQuery} />
    </div>
  </div>
  <div class="topbar-right">
    <div class="metric-pill" title="Active agent runs">
      <span class="status-dot active"></span>
      <span>{activeCount} active</span>
    </div>
    <div class="metric-pill" title="Pending runs">
      <span class="status-dot pending"></span>
      <span>{pendingCount} pending</span>
    </div>
    <div class="metric-pill">
      <span>⚡ OmniRouter</span>
    </div>
    <div class="timestamp">{currentTimestamp}</div>
  </div>
</header>

<style>
  .topbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 24px;
    border-radius: 0;
    border-top: none;
    border-left: none;
    border-right: none;
    margin-bottom: 0;
    background: var(--bg-panel);
    backdrop-filter: var(--blur-lg);
    -webkit-backdrop-filter: var(--blur-lg);
  }

  .topbar-left {
    flex: 1;
    max-width: 480px;
  }

  .search-box {
    display: flex;
    align-items: center;
    gap: 10px;
    background: var(--glass-bg);
    border: 1px solid var(--glass-border);
    border-radius: var(--radius-md);
    padding: 8px 14px;
    transition: all var(--transition-fast);
  }

  .search-box:focus-within {
    border-color: var(--accent-primary);
    box-shadow: 0 0 0 3px rgba(124, 92, 255, 0.1);
  }

  .search-icon {
    color: var(--text-muted);
    font-size: 18px;
  }

  .search-box input {
    flex: 1;
    border: none;
    background: transparent;
    color: var(--text-primary);
    font-size: 14px;
    outline: none;
  }

  .search-box input::placeholder {
    color: var(--text-muted);
  }

  .topbar-right {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  .metric-pill {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 6px 12px;
    background: var(--glass-bg);
    border: 1px solid var(--glass-border);
    border-radius: 20px;
    font-size: 12px;
    color: var(--text-secondary);
    white-space: nowrap;
  }

  .timestamp {
    font-size: 12px;
    color: var(--text-muted);
    font-variant-numeric: tabular-nums;
    padding: 6px 12px;
  }
</style>